//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../GeometricAnalysis/GeometricAnalysis.AnalysisObject.js";
import "../no/DesignSimulation.js";
let d=[[[0,"Study",0,"DesignSimulation.Study",0]],[[[],"Activate",{},0,0],[[],"Deactivate",{},0,0],[[],"CloneSimulation",{R_:{clonedSolution:"GeometricAnalysis.PerformancePredictor"}},0,0],[["journalIdentifier"],"FindObject",{R_:{study:"INXObject"}},1,0],[["fileNameAndPath"],"ExportToJsonFile",{},1,0],[[],"RemoveResults",{},0,0],[["solveOption"],"Analyze",{},1,0]],[]];
SPLM.GeometricAnalysis.PerformancePredictor = class extends SPLM.GeometricAnalysis.AnalysisObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.PerformancePredictor";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.PerformancePredictor.SolveOption = Object.freeze({
    "Foreground" : "Foreground", "Background" : "Background"});

export default SPLM;